import { Rectangle, PolyLine, Circle, Line, PolarLine, Arc, Text } from "./utils"
import {
  AnahtarliOtomatikSigorta,
  BulasikMak,
  CamasirMak,
  CihazBox,
  Firin,
  KacakAkim,
  Mak,
  PanoTali,
  Priz,
  Lamba,
  Anahtar,
  YuvarlakSolid,
  Sayac,
  PanoAnaTali,
  Boru
} from "./symbols"
import { createTekHatSema, TEK_HAT_BASE_DATA } from "./generateTekHatSema"

// Benzersiz ID sayacı
let textIdCounter = 0;

// Sabit değerler
const SABIT_DEGERLER = {
  // Tek Hat Schema'dan tüm base veriler alınıyor
  ...TEK_HAT_BASE_DATA,
  // ========== KOLON ŞEMASINA ÖZEL OVERRIDE'LAR ==========
  // Panel adları
  panelNames: ["MUTFAK PANOSU"],
  // Koruma röleleri
  protectionRelays: {
    zkt: "Z.K.T.",     // Zeminde kaçak akım tertibatı
    nktCount: 7        // Nötrde kaçak akım tertibatı sayısı
  },
  grounding: [
    "ANA SU BORUSU",
    "BİNA GİRİŞ DAĞITIM PANOSU",
    //"ASANSÖR RAYLARI",                 
    //"KABLO MERDİVENİ",                 
    "P.d. iletkeni en az 16 mm² NYAF",
  ]
};

function calculateDynamicPositions(itemCount, Scl) {
  const positions = [];
  const textSizes = [];
  const startOffset = -45 * Scl;
  const spacing = -20 * Scl;

  for (let i = 0; i < itemCount; i++) {
    positions.push(startOffset + (i * spacing));

    // Text boyutları - son iki eleman küçük
    if (i >= itemCount - 2 && itemCount > 2) {
      textSizes.push(9 * Scl);
    } else {
      textSizes.push(10 * Scl);
    }
  }

  return { positions, textSizes };
}


export const createKolonSema = (data) => {
   let result = [];
  const Scl = 1;
  const {
    branchies = [],     // Default empty array to prevent length errors
    feeder = null       // Default null for safe checking
  } = data || {};   
  const headerHeight = 50 * Scl
 
const cableText=data?.kolonDetails?.cable   || "4x6 mm² NYY"
const breakerText1=data?.kolonDetails?.breaker?.text1 || "C-3x40A "
const breakerText2=data?.kolonDetails?.breaker?.text2 || "10kA"
const rcdText1=data?.kolonDetails?.rcd?.text1 || "40A 4P/300 mA"
const rcdText2=data?.kolonDetails?.rcd?.text2 || "(25-32)A"
const rcdText3=data?.kolonDetails?.rcd?.text3 || "YKŞ"
const countOfOut = branchies.length;

  const layers = {
    0: { name: '0', frozen: false, visible: true, colorIndex: 7, color: 16777215 },
    18: { name: '18', frozen: false, visible: true, colorIndex: 1, color: 16711680 },
    AKSYAZI: { name: 'AKSYAZI', frozen: false, visible: true, colorIndex: 9, color: 12632256 }
  };

  const layer = layers.AKSYAZI;
  const options = {
    color: layer.color,
    colorIndex: layer.colorIndex,
    layer: layer.name,
    shape: true,
    hasContinuousLinetypePattern: false
  };

  const textHeight = 10 * Scl;
  const offsetOuts = 20 * Scl
  // Ana çerçeve boyutları
  const mainFrameWidth = 20 * Scl;
  const mainFrameX = 50 * Scl;
  const mainFrameY = 10 * Scl
const extraOffsetY = countOfOut > 12 ? (countOfOut - 12) * offsetOuts : 0;
  // Ana başlık
 
 
  textIdCounter++;
let  text = {
    text: data.kolonDetails.panelName||"Sayaç Panosu",
    x: mainFrameX + 400 * Scl,
    y: mainFrameY + 340 * Scl+(countOfOut-1)*offsetOuts-extraOffsetY,
    textHeight: 14 * Scl,
    id: `sayac_panosu_title_${textIdCounter}`
  };
  text.handle = text.id;

  result.push(Text(text.x, text.y, text, 0, options));

  // Mavi çerçeve (sayaç panosu kutusu)
  const frameX = mainFrameX + 200 * Scl;
  const frameY = mainFrameY + headerHeight+(countOfOut-1)*offsetOuts-extraOffsetY
  const blueframeX = mainFrameX + 300 * Scl;
  const blueframeY = mainFrameY + 210 * Scl+(countOfOut-1)*offsetOuts-extraOffsetY;
  const blueFrameOptions = { ...options, colorIndex: 4, color: 0x0000FF };
  result.push(Rectangle(blueframeX + -10, blueframeY, 330 * Scl, 120 * Scl, blueFrameOptions));

  // YEDAŞ kutusu
  const redFrameX = mainFrameX + 20 * Scl;
  const redFrameY = mainFrameY + 240 * Scl+(countOfOut-1)*offsetOuts-extraOffsetY;
  const redFrameWidth = 60 * Scl;
  const redFrameHeight = 20 * Scl;
  result.push(Rectangle(redFrameX, redFrameY, redFrameWidth, redFrameHeight, blueFrameOptions)); // Kırmızı çerçeve 
  textIdCounter++;
  text = {
    text: "YEDAŞ",
    x: redFrameX + 13 * Scl,
    y: redFrameY + 10 * Scl,
    textHeight: textHeight,
    id: `yedas_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  textIdCounter++;
  text = {
    text: cableText,
    x: frameX + -70 * Scl,
    y: frameY + 205 * Scl,
    textHeight: textHeight,
    id: `${cableText}_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  result.push(...Boru(frameX + 60 * Scl, frameY + 200 * Scl, 150 * Scl, Scl, 180, options));
  textIdCounter++;
  text = {
    text: "φ=100 Pe (kangal) boru",
    x: frameX + -20 * Scl,
    y: frameY + 170 * Scl,
    textHeight: 8 * Scl,
    id: `boru_kangal_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  result.push(...AnahtarliOtomatikSigorta(frameX + 118 * Scl, frameY + 200 * Scl, Scl, 3, 0, options));
  textIdCounter++;
  text = {
    text: breakerText1+"/"+breakerText2,
    x: frameX + 90 * Scl,
    y: frameY + 215 * Scl,
    textHeight: textHeight,
    id: `${breakerText1}_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  // Sayaç sembolü
  result.push(...Sayac(frameX + 360 * Scl, frameY + 240 * Scl, Scl, 3, 0, options));

  // 40A 4P/300 mA
  textIdCounter++;
  text = {
    text: rcdText1,
    x: frameX + 210 * Scl,
    y: frameY + 240 * Scl,
    textHeight: textHeight,
    id: `${rcdText1}_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  // Y.K'lı T.M.Ş
  textIdCounter++;
  text = {
    text: rcdText2,
    x: frameX + 220 * Scl,
    y: frameY + 230 * Scl,
    textHeight: textHeight,
    id: `${rcdText2}_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  // (30-40)
  textIdCounter++;
  text = {
    text: rcdText3,
    x: frameX + 230 * Scl,
    y: frameY + 220 * Scl,
    textHeight: textHeight,
    id: `${rcdText3}_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  // Kaçak akım koruma rölesi sembolü
  result.push(...KacakAkim(frameX + 240 * Scl, frameY + 200 * Scl, Scl, 0, options));



  // Bağlantı çizgileri
   result.push(PolarLine(frameX + 250 * Scl, frameY + 200 * Scl, 0, 100 * Scl, options));
   
  result.push(PolarLine(frameX + 130 * Scl, frameY + 200 * Scl, 0, 100 * Scl, options));
  result.push(PolarLine(frameX + -120 * Scl, frameY + 200 * Scl, 0, 226 * Scl, options));


  result.push(PolarLine(frameX + 360 * Scl, frameY + 130 * Scl, 0, 80 * Scl, options));


  // Dikey bağlantı çizgisi (aşağı doğru)
  const verticalLineX = frameX + 200 * Scl;
  result.push(PolarLine(verticalLineX + 170 * Scl, frameY + 220 * Scl, -90, 20 * Scl, options));
  result.push(PolarLine(verticalLineX + 150 * Scl, frameY + 220 * Scl, -90, 20 * Scl, options));


  // ALT BÖLÜM
  const listStartY = frameY + 180 * Scl;
  const listX = mainFrameX + 100 * Scl;

  // Topraklama elemanları
  const groundingItems = data?.grounding || SABIT_DEGERLER.grounding || [];
  const { positions: groundingPositions, textSizes: groundingTextSizes } = calculateDynamicPositions(groundingItems.length, Scl);




  const redOptions = { ...options, colorIndex: 1, color: 0xFF0000 };
  const dotX = verticalLineX + 160 * Scl;

  groundingItems.forEach((item, index) => {
    const textY = listStartY + groundingPositions[index];
    const lineY = textY - 5 * Scl;

    // Text çiz
    textIdCounter++;
    text = {
      text: item,
      x: listX + 250 * Scl,
      y: textY,
      textHeight: groundingTextSizes[index],
      id: `grounding_${index}_${textIdCounter}`
    };

    text.handle = text.id;
    result.push(Text(text.x, text.y, text, 0, options));

    // Yatay bağlantı çizgisi
    result.push(PolarLine(
      dotX,
      lineY,
      180,
      220 * Scl, // Çizgi uzunluğu
      options
    ));

    // Kırmızı nokta 
    result.push(...YuvarlakSolid(
      dotX,
      lineY,
      3 * Scl,
      Scl,
      redOptions
    ));
  });

  if (groundingItems.length > 0) {
    const lastTextY = listStartY + groundingPositions[groundingPositions.length - 1];
    const lastLineY = lastTextY - 5 * Scl; // En son çizginin Y pozisyonu
    const dynamicVerticalLength = (frameY + 220 * Scl) - lastLineY; // Dinamik uzunluk
    result.push(PolarLine(verticalLineX + 160 * Scl, frameY + 220 * Scl, -90, dynamicVerticalLength, options));
  }

  //Topraklama
  const rightX = mainFrameX + 600 * Scl;
  const rightY = listStartY;

  // Bağlantı filizi
  textIdCounter++;
  text = {
    text: "Bağlantı filizi",
    x: rightX + -30 * Scl,
    y: rightY + -45 * Scl,
    textHeight: textHeight,
    id: `baglanti_filizi_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  // 30.5 Galvanizli
  textIdCounter++;
  text = {
    text: "30.5 Galvanizli",
    x: rightX + -30 * Scl,
    y: rightY + -60 * Scl,
    textHeight: textHeight,
    id: `galvanizli_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  // Çelik şerit
  textIdCounter++;
  text = {
    text: "Çelik şerit",
    x: rightX + -30 * Scl,
    y: rightY + -70 * Scl,
    textHeight: textHeight,
    id: `celik_serit_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  // Topraklama levhaları (sağ alt)
  textIdCounter++;
  text = {
    text: "Topraklama",
    x: rightX + 15 * Scl,
    y: rightY + -120 * Scl,
    textHeight: textHeight,
    id: `topraklama_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  textIdCounter++;
  text = {
    text: "levhaları    0.5",
    x: rightX + 15 * Scl,
    y: rightY + -130 * Scl,
    textHeight: textHeight,
    id: `levhalari_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  textIdCounter++;
  text = {
    text: "mm² Cu",
    x: rightX + 15 * Scl,
    y: rightY + -140 * Scl,
    textHeight: textHeight,
    id: `mm2_cu_${textIdCounter}`
  };
  text.handle = text.id;
  result.push(Text(text.x, text.y, text, 0, options));

  // Topraklama sembolü
  const groundSymbolX = rightX + 40 * Scl;
  const groundSymbolY = rightY + -110 * Scl;
  result.push(PolarLine(groundSymbolX, groundSymbolY - -60 * Scl, -90, 40 * Scl, options));
  result.push(PolarLine(groundSymbolX - 15 * Scl, groundSymbolY + 20 * Scl, 0, 30 * Scl, options));
  result.push(PolarLine(groundSymbolX - 12 * Scl, groundSymbolY + 15 * Scl, 0, 24 * Scl, options));
  result.push(PolarLine(groundSymbolX - 9 * Scl, groundSymbolY + 10 * Scl, 0, 18 * Scl, options));
  result.push(PolarLine(groundSymbolX - 6 * Scl, groundSymbolY + 5 * Scl, 0, 12 * Scl, options));


  data.x=580*Scl
  data.y=extraOffsetY
  data.yOffset=220*Scl  // tekHat ana besleme hattını sayaç çıkışının ucuna hizala
  const tekHatSema = createTekHatSema(data)
  const tekHatResult = tekHatSema.result
  const tekHatWidth = tekHatSema.width
  const tekHatHeight = tekHatSema.height
  result = result.concat(tekHatResult); 

  //-------------------------
  const headerTextWidth=235*Scl
  const kolonSemaWidth=mainFrameWidth + tekHatWidth + 100 * Scl
  const kolonSemaHeight=   tekHatHeight + 0 * Scl

  // Çerçeve Y koordinatları
  const contentTopY = kolonSemaHeight + 2 * headerHeight - mainFrameY  // kH + 90 (header alt çizgisi = içerik üst çizgisi)
  const frameTopY = contentTopY + headerHeight                         // kH + 140 (header dahil frame üstü)

  // Header text - header alanının ortasında
  text = {
      text: "KOLON ŞEMASI",
      x: kolonSemaWidth/2-headerTextWidth/2,
      y: contentTopY + headerHeight * 0.3,
      textHeight:22.5 * Scl,
      id: `title_text_header_KolonSema`
    };
    text.handle = text.id;
    result.push(Text(text.x, text.y, text, 0, options));
  //-------------------------DOCFRAME-------------
  const  vertices=[
      { x:0, y:2 * headerHeight, z:0 },
      { x:0, y:frameTopY, z:0 },
      { x:kolonSemaWidth, y:frameTopY, z:0 },
      { x:kolonSemaWidth, y:2 * headerHeight, z:0 },
    ]
    options.shape=true
     result.push(PolyLine(0,0,vertices,options))
  // Header separator: header alt çizgisi = içerik üst çizgisi
  result.push(PolarLine(0, contentTopY, 0, kolonSemaWidth, options));


  return {
    result: result,
    width:kolonSemaWidth,
    height:frameTopY
  };
};
